const PORTAL_PREFIX = '/portal'
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(REDUCED_MOTION_QUERY).matches
}

export function shouldAnimateTransition(fromPath: string, toPath: string): boolean {
  if (prefersReducedMotion()) return false
  if (fromPath === toPath) return false
  if (fromPath.startsWith(PORTAL_PREFIX) || toPath.startsWith(PORTAL_PREFIX)) return false
  return true
}

export function parseInternalHref(href: string): { pathname: string; search: string; hash: string } | null {
  try {
    const url = new URL(href, window.location.origin)
    if (url.origin !== window.location.origin) return null
    return {
      pathname: url.pathname,
      search: url.search,
      hash: url.hash,
    }
  } catch {
    return null
  }
}

export function hrefToPath({ pathname, search, hash }: { pathname: string; search: string; hash: string }): string {
  return `${pathname}${search}${hash}`
}

export function nextFrame(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => resolve())
  })
}

/** Scroll to in-page hash after Barba has swapped the displayed route. */
export function scrollToLocationHash(location: { hash: string }): boolean {
  if (!location.hash) return false
  let id: string
  try {
    id = decodeURIComponent(location.hash.slice(1))
  } catch {
    return false
  }
  if (!id) return false
  const el = document.getElementById(id)
  if (!el) return false
  el.scrollIntoView({ behavior: 'smooth' })
  return true
}

export function scrollAfterBarbaNavigation(target: { pathname: string; hash: string }, fromPathname: string): void {
  if (target.hash) {
    const found = scrollToLocationHash(target)
    if (!found && target.pathname !== fromPathname) {
      window.scrollTo(0, 0)
    }
    return
  }
  if (target.pathname !== fromPathname) {
    window.scrollTo(0, 0)
  }
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
